import React, { useState } from 'react';
import logo from '../assets/PARED2_Mesa de trabajo 1 - copia.jpg';
import logoSmall from '../assets/logo-04.png';
import './login.css';
import { useNavigate } from 'react-router-dom'; 
import { AuthService, Login } from '../services/login.service';

const Home = () => {
    const navigate = useNavigate(); 
    const [form, setForm] = useState({
        username: '',
        password: '',
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Si es el username, lo guardamos en minúsculas inmediatamente
        if (name === 'username') {
            setForm({ ...form, [name]: value.toLowerCase() });
        } else {
            setForm({ ...form, [name]: value });
        }
        setError('');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            // Ya no necesitamos convertir a minúsculas aquí porque ya está en minúsculas
            await Login({ 
                user: form.username, 
                password: form.password 
            }, (flag, response) => {
                if (flag) {
                    // Guardamos en localStorage también en minúsculas
                    localStorage.setItem('credenciales', JSON.stringify({ 
                        user: form.username, 
                        password: form.password,
                        uid: response
                    }));
                    if(response.is_admin){
                        navigate('/admin');
                        window.location.reload();
                    } else {
                        navigate('/alumnos');
                        window.location.reload();
                    }
                } else {
                    setError('Correo o contraseña incorrectos');
                }
            });
        } catch (error) {
            console.error('Error en handleSubmit:', error.message);
            setError('Error de servidor. Inténtalo de nuevo más tarde.');
        }
    };

    return (
        <div className="home-container">
            <img src={logo} alt="Fondo" className="background-image" />
            
            <div className="form-container">
                <div className="form-box">
                    <div className="logo-container">
                        <img src={logoSmall} alt="Logo" className="logo-image" />
                    </div>
                    
                    <h2 className="inicio" style={{textAlign:'center', color:'white'}}>Iniciar Sesión</h2>
                    
                    {error && (
                        <div className="error-message" style={{
                            color: 'red',
                            textAlign: 'center',
                            marginBottom: '10px',
                            backgroundColor: 'rgba(255, 0, 0, 0.1)',
                            padding: '8px',
                            borderRadius: '4px'
                        }}>
                            {error}
                        </div>
                    )}
                    
                    <form onSubmit={handleSubmit}>
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="username"
                                placeholder=" "
                                value={form.username}
                                onChange={handleChange}
                                className="input-field"
                                required
                            />
                            <label className="floating-label">Correo Electrónico</label>
                        </div>
                        
                        <div className="input-wrapper">
                            <input
                                type="password"
                                name="password"
                                placeholder=" "
                                value={form.password}
                                onChange={handleChange}
                                className="input-field"
                                required
                            />
                            <label className="floating-label">Contraseña</label>
                        </div>
                        
                        <button type="submit" className="submit-button">
                            Iniciar Sesión
                        </button>
                    </form>
                    
                    <div className="forgot-password">
                        <a href="#">¿Olvidaste tu contraseña?</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;